import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const mechanicApi = createApi({
  reducerPath: 'mechanicApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Mechanic', 'Mechanics', 'Response'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
